<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont"> {{ $t('Current-Card-General-Purpose-Report') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field v-show="!dizaynView" flat="" solo-inverted="" hide-details v-model="search" :label="$t('Search')"
              append-icon="search">
            </v-text-field>

            <v-menu bottom left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile v-show="!dizaynView" @click="RaporGetirExcel()">
                  <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-show="!dizaynView" @click="DizaynEkleSor()">
                  <v-list-tile-title> {{ $t('Add-Design') }} </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-show="!dizaynView" @click="DesignShow()">
                  <v-list-tile-title> {{ $t('Change-Design') }} </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="Dizaynsil()">
                  <v-list-tile-title> {{ $t('Delete-Design') }} </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="islemIptal()" v-show="dizaynView">
                  <v-list-tile-title> {{ $t('Cancel-Process') }} </v-list-tile-title>
                </v-list-tile>

              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
        <v-container fluid>

          <v-flex xs12 pb-2 pl-1 sm12 md12>
            <v-card flat>
              <v-layout v-show="!dizaynView" row wrap>


                <v-flex pt-2 pl-1 xs12 sm4 md4>

                  <raporsablon v-show="true" :menudisable="false" ref="raporsablon" v-model="sablon"
                    dizayngrupadi="GenelAmacliCariHesap" objectname="Models.GenelAmacliRaporCariHesap"></raporsablon>
                </v-flex>

                <v-flex pt-2>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="RaporGetir()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green">
                          check_circle_outline </v-icon>
                      </template>

                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Add-Search-Filter')}}</span>
                      </v-tooltip>



                    </v-badge>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>


          <v-layout row wrap>

            <v-flex v-show="!dizaynView" xs12 sm12>
              <v-card flat>
                <v-data-table :headers="parseDesign()" :search="search" :rows-per-page-items=[50,100] :items="desserts"
                  class="elevation-1">
                  <template v-slot:items="props">
                    <td v-for="tableheader in parseDesign()" :key="tableheader.id">
                      {{props.item[tableheader.value]}}
                    </td>

                  </template>
                </v-data-table>

              </v-card>
            </v-flex>


            <v-flex xs12 v-show="dizaynView" pa-2 sm12 md12>
              <v-card flat>

                <v-layout row wrap>
                  <v-flex xs6 sm6 md6>
                    <v-icon medium="" color="info">settings</v-icon> &nbsp;
                    <span class=" font-weight-regular grey--text title"> {{ $t('Report-Design-Processes') }} </span>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-layout justify-end>


                      <v-tooltip bottom>
                        <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="DizaynKaydet()"
                          flat> <span class="hidden-sm-and-down"> {{$t('Save-Design')}}
                          </span>
                          <v-icon right dark>create</v-icon>
                        </v-btn>
                        <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                        <span v-if="sayfayetki.Update">{{$t('Save-Design')}}</span>
                      </v-tooltip>

                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>

            </v-flex>


            <v-flex xs6 v-show="dizaynView" pa-2 md6 sm6>
              <v-card flat>
                <v-flex xs12 md12 sm12>
                  <v-flex xs12 sm12 md12>
                    <v-system-bar window color="info">
                      <span class="white--text subheading"> {{ $t('Unselected-Spaces') }} </span>
                      <v-spacer></v-spacer>

                    </v-system-bar>
                  </v-flex>
                  <draggable class="list-group" tag="ul" v-model="dizaynData" v-bind="dragOptions" :move="onMove">
                    <transition-group type="transition" :name="'flip-list'">
                      <v-list v-for="element in dizaynData" :key="element.text" subheader>
                        <v-list-tile>
                          <v-flex xs12 md12 sm12>
                            <v-icon color="grey">drag_handle
                            </v-icon>
                            {{element.text}} <span class="grey--text caption"> ({{element.value}})</span>
                            <v-btn small color="green" slot="activator" @click="dialogacDuzenle(element,1)" flat>
                              <v-icon small>edit</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon @click="ItemAktar(dizaynData,dizaynData2,element)" color="green">arrow_forward_ios
                              </v-icon>
                            </v-btn>
                          </v-list-tile-action>

                        </v-list-tile>
                        <v-divider></v-divider>
                      </v-list>

                    </transition-group>
                  </draggable>
                </v-flex>
              </v-card>
            </v-flex>

            <v-flex v-show="dizaynView" xs6 pa-2 md6 sm6>
              <v-card flat>
                <v-flex xs12 md12 sm12>
                  <v-flex xs12 sm12 md12>
                    <v-system-bar window color="info">
                      <span class="white--text subheading"> {{ $t('Selected-Spaces') }} </span>
                      <v-spacer></v-spacer>
                    </v-system-bar>
                  </v-flex>

                  <draggable element="span" v-model="dizaynData2" v-bind="dragOptions" :move="onMove">
                    <transition-group name="no" class="list-group" tag="ul">
                      <v-list v-for="element in dizaynData2" :key="element.text" subheader>
                        <v-list-tile>
                          <v-flex xs12 md12 sm12>

                            <v-icon @click="ItemAktar(dizaynData2,dizaynData,element)" color="red">arrow_back_ios
                            </v-icon>

                            {{element.text}} <span class="grey--text caption"> ({{element.value}})</span>
                            <v-btn small :disabled="!sayfayetki.Update" color="green" slot="activator"
                              @click="dialogacDuzenle(element,2)" flat>
                              <v-icon small>edit</v-icon>

                            </v-btn>

                          </v-flex>

                          <v-list-tile-action>
                            <v-btn icon ripple>
                              <v-icon color="grey">drag_handle
                              </v-icon>
                            </v-btn>


                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                      </v-list>
                    </transition-group>
                  </draggable>

                </v-flex>
              </v-card>
            </v-flex>






            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
              :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
              v-model="snackbar">
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>

            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                <v-card-text>{{dialogmessage}}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" flat @click.native="karsicariac()">{{ $t('OK') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
              <v-card flat color="grey lighten-5">

                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-flex mt-2 xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">




                            <v-flex xs12 sm6 md12>
                                <cariaracomp v-bind:etiket="'Başlangıç Cari'" v-bind:value="prm.BaslangicCari" :loading="loading"
                                  v-model="prm.BaslangicCari"></cariaracomp>
                            </v-flex>

                            <v-flex xs12 sm6 md12>
                                <cariaracomp v-bind:etiket="'Bitiş Cari'" v-bind:value="prm.BitisCari" :loading="loadingbitiscari"
                                  v-model="prm.BitisCari"></cariaracomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-autocomplete hide-details="" clearable :items="hesapgurubu" :label="$t('Account-Groups')"
                                multiple item-text="Title" v-model="prm.HesapGruplari" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Title }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{
                                                               prm.HesapGruplari.length -
                                                                1
                                                                }} {{ $t('Other') }})</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                                 <cariaracomp v-bind:etiket="$t('Main-Account')" v-bind:value="prm.AnaHesap" :loading="loadingana"
                                  v-model="prm.AnaHesap"></cariaracomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-autocomplete hide-details :items="masrafmerkezi" clearable v-model="prm.Masraflar"
                                :label="$t('Expense-Center-v2')" multiple item-text="Title" item-value="Code">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Code }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                                               prm.Masraflar.length -
                                                                1
                                                                }} {{ $t('Other') }})</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-autocomplete hide-details :items="analizitems" clearable v-model="prm.AnalizKodlari"
                                :label="$t('Analysis-Codes')" multiple item-text="Title" item-value="AnalizKod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.AnalizAdi }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                                               prm.AnalizKodlari.length -
                                                                1
                                                                }} {{ $t('Other') }})</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                              <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" v-model="prm.Yetkili" :label="$t('Authorized_label')"></v-text-field>
                            </v-flex>

                            <v-layout row wrap>

                              <v-flex xs12 pb-1 pt-3 sm12 md12>
                                <span class=" font-weight-regular grey--text title"> {{$t('Options-v2')}} </span>
                                <v-divider></v-divider>
                              </v-flex>
                              <v-flex xs12 sm5 md6>
                                <v-radio-group v-model="prm.CariTipi" :label="$t('Current-Type')" hide-details>
                                  <v-radio :value="0" :label="$t('All')"></v-radio>
                                  <v-radio :value="1" :label="$t('Registered-with-E-invoice')"></v-radio>
                                  <v-radio :value="2" :label="$t('Not-Registered-with-E-invoice')"></v-radio>
                                </v-radio-group>
                              </v-flex>
                              <v-flex xs12 sm3 md6>
                                <v-radio-group v-model="prm.EFaturaTipi" :label="$t('E-invoicetype')" hide-details>
                                  <v-radio :value="0" :label="$t('All')"></v-radio>
                                  <v-radio :value="1" :label="$t('Commercial')"></v-radio>
                                  <v-radio :value="2" :label="$t('Basic')"></v-radio>
                                  <v-radio :value="3" :label="$t('Export')"></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>


                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                  <v-btn color="blue darken-1" flat @click="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogyenideger" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">{{ $t('Edit') }}</v-card-title>
                <v-card-text>
                  <v-flex xs12 sm12 md12>
                    <v-text-field hide-details="" v-model="yeniDeger" :label="$t('Field-Title-Shown-Report')">
                    </v-text-field>
                  </v-flex>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="info" flat @click.native="yazdir1()">{{ $t('OK') }}</v-btn>
                  <v-btn color="info" flat @click.native="dialogyenideger=false">{{$t("cancel_button")}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogdizaynEkle" scrollable="" persistent="" max-width="400px">
              <v-card color="grey lighten-4">
                <v-card-title>{{ $t('Add-Design') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-flex ma-1 xs12 sm12 md12>

                    <v-layout row="" wrap="">
                      <div class="flex md12">
                        <v-text-field hide-details="" v-model="dizaynAdi" :label="$t('Design-Name')"></v-text-field>
                      </div>
                    </v-layout>

                  </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click.native="dialogdizaynEkle=false">{{$t("cancel_button")}}</v-btn>
                  <v-btn color="blue darken-1" flat @click="DizaynEkle()">{{ $t('Add-Design') }} </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>



          </v-layout>
        </v-container>

        <v-container fluid>
          <v-layout row wrap>

          </v-layout>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainput from '@/components/app/customcomp/parainput'
  import dovizinput from '@/components/app/customcomp/dovizinput'
  import yuzdeinput from '@/components/app/customcomp/yuzdeinput'
  import tarihim from '@/components/app/customcomp/tarihim'
  import kesenkisi from '@/components/app/customcomp/kesenkisi'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import draggable from "vuedraggable";
  import tool from "@/components/app/coper/tools.js";
  import raporsablon from "@/components/app/coper/comp/raporsablon.vue";
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'




  export default {


    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        bankapositems: [],
        loadingvmodel: false,
        hesapgurubu: [],
        loadingbitiscari: false,
        statebitiscari: [],
        searchbitiscari: null,
        analizitems:[],

        evraktipi: [],
        filtrevarmi: false,
        sablon: {

          design: []
        },
        desserts: [],
        loadingana: false,
        statecariana: [],
        searchcariana: null,


        islemdizisi: null,
        dialogyenideger: false,
        duzenlenenkayit: null,
        yeniDeger: null,

        prm: {
          BaslangicCari: null,
          Yetkili:null,
          BitisCari: null,
          SirketKodu: null,
          HesapGruplari: [],
          AnaHesap: null,
          AnalizKodlari: [],
          Masraflar: [],
          CariTipi: 0, // 0 : Hepsi, 1 : E-Fatura Kayıtlı, 2 : E-Fatura Kayıtsız
          EFaturaTipi: 0 // 0 : Hepsi, 1 : Ticari, 2 : Temel, 3: İhracat
        },
        doviztipi: [],
        itemsairlinelist: [],
        Referans: [],
        masrafmerkezi: [],
        itemsparkur: [],
        classitems: [],
        hattipiitems: [{
            text: this.$t('All'),
            value: 0
          },
          {
            text: this.$t('Domestic-Line'),
            value: 1
          },
          {
            text: this.$t('International-Line'),
            value: 2

          },
          {
            text: 'BSP',
            value: 3

          },

        ],
        satistipiitems: [{
            text: this.$t('All'),
            value: 0
          },
          {
            text: this.$t('Sales'),
            value: 1
          },
          {
            text: this.$t('Refund'),
            value: 2

          }
        ],
        odemetipiitems: [{
            text: this.$t('All'),
            value: 0
          },
          {
            text: this.$t('With-Credit'),
            value: 1
          },
          {
            text: this.$t('Cash'),
            value: 2

          },
          {
            text: this.$t('R-Card'),
            value: 3

          },
          {
            text: this.$t('F-Card'),
            value: 4

          },
          {
            text: this.$t('C-Card'),
            value: 5

          }
        ],
        biletyonitems: [{
            text: this.$t('All'),
            value: 0
          },
          {
            text: 'Tek Yön ',
            value: 1
          },
          {
            text: 'Çift Yön',
            value: 2

          },
          {
            text: 'Ressiue',
            value: 3

          }
        ],
        classtipiitems: [{
            text: 'B-Business',
            value: 'B'
          },
          {
            text: 'C-Premium Economy',
            value: 'C'
          },
          {
            text: 'E-Economy',
            value: 'E'
          },
          {
            text: this.$t('First-Class'),
            value: 'F'
          },
          {
            text: this.$t('Promotion'),
            value: 'P'
          },
          {
            text: 'X-Infant',
            value: 'X'
          }
        ],
        crsitems:  [
        {
                text: 'Manuel',
                value: 'Manuel'
            }, {
                text: '1 - Amadeus ' + this.$t('International-Line'),
                value: 'AmadeusDisHat'
            }, {
                text: '2 - TK ' + this.$t('Domestic-Line'),
                value: 'TkIcHat'
            }, {
                text: '3 - Atlas',
                value: 'Atlas'
            }, {
                text: '4 - Pegasus',
                value: 'Pegasus'
            }, {
                text: '5 - Onur',
                value: 'Onur'
            }, {
                text: '6 - SunExpress',
                value: 'SunExpress'
            }, {
                text: '7 - Galileo ' + this.$t('Domestic-Line'),
                value: 'GalileoIcHat'
            }, {
                text: '8 - Galileo ' + this.$t('International-Line'),
                value: 'GalileoDisHat'
            }, {
                text: '9 - WorldSpan',
                value: 'Worldspan'
            }, {
                text: '10 - BoraJet',
                value: 'BoraJet'
            }, {
                text: '11 - IATI',
                value: 'IATI'
            }, {
                text: '12 - Sabre',
                value: 'Sabre'
            }, {
                text: '13 - Bilet Bank',
                value: 'BiletBank'
            }, {
                text: '14 - Kolay Bilet',
                value: 'KolayBilet'
            },
             {
                text: '15 - Air Arabia',
                value: 'AirArabia'
            },
             {
                text: '16 - Corendon',
                value: 'Corendon'
            },
             {
                text: '17 - Puzzle',
                value: 'Puzzle'
            },
            {
                text: '18 - AmadeusAPI',
                value: 'AmadeusAPI'
            },
            {
                text: '19 - THYAPI',
                value: 'AmadeusAPI'
            },
            {
                text: '20 - PegasusAPI',
                value: 'PegasusAPI'
            },
            {
                text: '21 - SunExpressAPI',
                value: 'SunExpressAPI'
            },
            {
                text: '22 - AtlasGlobalAPI',
                value: 'AtlasGlobalAPI'
            },
            {
                text: '23 - OnurAirAPI',
                value: 'OnurAirAPI'
            },
            {
                text: '24 - GalileoAPI',
                value: 'GalileoAPI'
            },
            {
                text: '25 - SabreAPI',
                value: 'SabreAPI'
            },
            {
                text:'26 - Amadeus Ic Hat',
                value:'AmadeusIcHat'
            },
            {
                text:'27 - Turkmenistan Airline',
                value:'TurkmenistanAirline'
            },
            {
                text:'28 - BookingAgora',
                value:'BookingAgora'
            },
            {
                text:'33 - BiziTravel',
                value:'BiziTravel'
            },
            { text:'39 - SabreLCC', value:'SabreLCC' },
            {
                text:'98 - AerTicket',
                value:'AerTicket'
            },
            {
                text:'99 - ArkmanAktarim',
                value:'ArkmanAktarim'
            },
            {
                text:'97 - OtelFirsati',
                value:'OtelFirsati'
            },
            {
                text:'29 - Germania',
                value:'Germania'
            },
            {
                text:'30 - VadeFarki',
                value:'VadeFarki'
            },
            {
                text:'31 - SMS',
                value:'SMS'
            },
            {
                text:'32 - Bilgilendirme',
                value:'Bilgilendirme'
            },
            {
                text:'34 - Airays',
                value:'Airays'
            },
            {
                text:'35 - NDC',
                value:'NDC'
            },
            {
                text:'36 - Travelfusion',
                value:'Travelfusion'
            },
            {
                text:'37 - Greencode',
                value:'Greencode'
            },
           
            {
                text:'40 - AJET',
                value:'AJet'
            },
            {
                text:'41 - FlyKhy',
                value:'FlyKhy'
            },
            {
                text:'42 - BiletAll',
                value:'BiletAll'
            },
            
              {
                text:'44 - Freebird',
                value:'Freebird'
            },
            {
                text:'45 - HisarEurope',
                value:'HisarEurope'
            }
          ],


        id: 3,
        name: "handle",
        display: "Handle",
        instruction: "Drag using the handle icon",
        order: 5,

        list: [{
            name: "John",
            text: "",
            id: 0
          },
          {
            name: "Joao",
            text: "",
            id: 1
          },
          {
            name: "Jean",
            text: "",
            id: 2
          }
        ],

        dragging: false,
        dizaynData2: [],
        dizaynData: [],
        dizaynView: false,
        dizaynAdi: null,
        dialogdizaynEkle: false,

        list2: [],
        editable: true,
        isDragging: false,
        delayedDragging: false,


        search: '',

        date: null,
        islemdurumu: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        harekettipi: '',
        items: [],

        tooltip: false,
        el: null,
        StartDate: null,
        EndDate: null,
        load: false,
        load1: true,
        dialogmessage: '',
        dialog: false,
        progress: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        statecari: [],
        loading: false,
        searchcari: null,
        dialogfiltre: false,
        evraktipi: [],
        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsecbit: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }

    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },

    watch: {
      isDragging(newValue) {
        if (newValue) {
          this.delayedDragging = true;
          return;
        }
        this.$nextTick(() => {
          this.delayedDragging = false;
        });
      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      filtrekayit() {
        this.filtrevarmi = true
        this.dialogfiltre = false
        this.RaporGetir();
      },
      dialogacDuzenle(a, b) {
        this.duzenlenenkayit = a
        this.islemdizisi = b
        this.yeniDeger = a.text
        this.dialogyenideger = true
      },

      yazdir2() {
        var indexno = this.dizaynData2.indexOf(this.duzenlenenkayit)
        this.duzenlenenkayit.text = this.yeniDeger
        this.dizaynData2.splice(indexno, 1, this.duzenlenenkayit)
        this.dialogyenideger = false

      },
      yazdir1() {
        var indexno = this.dizaynData.indexOf(this.duzenlenenkayit)
        this.duzenlenenkayit.text = this.yeniDeger
        this.dizaynData.splice(indexno, 1, this.duzenlenenkayit)
        this.dialogyenideger = false

      },

      filtreiptal() {
        this.dialogfiltre = false
        this.filtrevarmi = false
        this.prm.BaslangicCari = null
        this.prm.BitisCari = null
        this.prm.HesapGruplari = []
        this.prm.AnaHesap = null
        this.prm.AnalizKodlari = []
         this.prm.Yetkili=null,

        this.prm.Masraflar = []
        this.prm.CariTipi = 0 // 0 : Hepsi, 1 : E-Fatura Kayıtlı, 2 : E-Fatura Kayıtsız
        this.prm.EFaturaTipi = 0 // 0 : Hepsi, 1 : Ticari, 2 : Temel, 3: İhracat
        this.RaporGetir();
      },
      filtrele() {
        //filtrele ekranı
        this.dialogfiltre = true
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.masrafmerkezi = response.body
        }, (response) => {
          if (response.status === 0) {} else {}
        })



          this.$http.post(auth.API_URL + 'api/Analysis/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.analizitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })



        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapgurubu = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      },


      DizaynEkleSor() {
        this.dialogdizaynEkle = true
      },
      DizaynEkle() {
        tool.api_post(this, "RaporSablon/GetReportBroDesignInsert", {
            id: 0,
            ad: this.dizaynAdi,
            reportBroGrupAdi: 'GenelAmacliCariHesap',
            objectName: 'Models.GenelAmacliRaporCariHesap'
          })
          .then(
            response => {
              var prmm = {
                id: 0,
                ad: 'GenelAmacliCariHesap',
                objectName: 'Models.GenelAmacliRaporCariHesap'
              }

              this.$refs.raporsablon.sablonGetirout(prmm);
              this.dialogdizaynEkle = false
              this.text1 = this.$t('Design-has-been-saved')
              this.snackbar = true
              this.dizaynView = false
            },
            response => {
              this.text1 = this.$t('Error')
              this.snackbar = true

            }
          );
      },
      DizaynKaydet() {
        var d = [];
        var i;
        for (i = 0; i < this.dizaynData2.length; i++) {
          var item = {
            text: this.dizaynData2[i].text,
            value: this.dizaynData2[i].value,
            selected: true
          }
          d.push(item);
        }
        for (i = 0; i < this.dizaynData.length; i++) {
          var item = {
            text: this.dizaynData[i].text,
            value: this.dizaynData[i].value,
            selected: false
          }
          d.push(item);
        }

        var djosn = JSON.stringify(d);

        tool.api_post(this, "RaporSablon/TableDesignSave", {
            id: this.sablon.id,
            design: djosn
          })
          .then(
            response => {

              var prmm = {
                id: 0,
                ad: 'GenelAmacliCariHesap',
                objectName: 'Models.GenelAmacliRaporCariHesap'
              }

              this.$refs.raporsablon.sablonGetirout(prmm);

              this.text1 = this.$t('Design-has-been-saved')
              this.snackbar = true
              this.dizaynView = false
            },
            response => {
              this.status = tool.responseToStatus(response);
            }
          );
      },
      Dizaynsil() {
        tool
          .api_post(this, "RaporSablon/GetReportBroDesignDelete", {
            id: this.sablon.id,
            ad: this.sablon.ad,
            design: null,
          })
          .then(
            response => {
              var prmm = {
                id: 0,
                ad: 'GenelAmacliCariHesap',
                objectName: 'Models.GenelAmacliRaporCariHesap'
              }

              this.$refs.raporsablon.sablonGetirout(prmm);

              this.text1 = this.$t('Design-has-been-deleted')
              this.snackbar = true
              this.dizaynView = false

            },
            response => {}
          );
      },

      islemIptal() {
        this.dizaynView = false
      },
      ItemAktar(kaynak, hedef, item) {
        var n = kaynak.indexOf(item);

        var temp = {
          text: item.text,
          value: item.value,
        };

        hedef.push(temp);
        kaynak.splice(n, 1);

      },
      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return ((!relatedElement || !relatedElement.fixed) && !draggedElement.fixed);

      },

      DesignShow() {

        tool.api_post(this, "RaporSablon/TableDesignRead", {
          value: this.sablon.id,
        }).then(
          response => {

            var temp = JSON.parse(response.body);
            this.dizaynData2 = [];
            this.dizaynData = [];
            this.dizaynView = true

            var i;
            for (i = 0; i < temp.length; i++) {
              if (temp[i].selected) {
                this.dizaynData2.push(temp[i]);
              } else {
                this.dizaynData.push(temp[i]);
              }
            }



          },
          response => {
            this.status = tool.responseToStatus(response);
            this.dizaynView = false
          }
        );

      },

      parseDesign() {
        if (this.sablon.design.length > 0) {

          var temp = JSON.parse(this.sablon.design);
          var r = [];
          var i;
          for (i = 0; i < temp.length; i++) {
            if (temp[i].selected) {
              r.push(temp[i]);
            }
          }
          return r;

        } else {
          return []
        }
      },
      RaporGetir: RaporGetir,
      RaporGetirExcel: RaporGetirExcel,
      getDateNow: getDateNow
    },
    computed: {
      draggingInfo() {
        return this.dragging ? "under drag" : "";
      },

      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: !this.editable,
          ghostClass: "ghost"
        };
      },
      listString() {
        return JSON.stringify(this.list, null, 2);
      },
      list2String() {
        return JSON.stringify(this.list2, null, 2);
      }
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      loadingcomp,
      draggable,
      tarihim,
      referansmerkezicomp,
      masrafmerkezicomp,
      raporsablon,
      kesenkisi,
      analizcomp,
      yetkidialog,
      cariaracomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }

    },


  }





  function beforeMount() {


  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function RaporGetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.progress = true

    this.prm.SirketKodu = credentials.SirketKodu


    this.load1 = false
    this.load = true
    var Params = this.prm


    this.$refs.raporsablon.Report(this.prm).then(
      confirm => {
        this.desserts = confirm;
        this.load1 = true
        this.load = false
      },
      confirm => {
        this.desserts = [];
        this.load1 = true
        this.load = false
      }
    );





  }

  function RaporGetirExcel() {
    this.dialogfiltre = false;

    
   if(this.sablon.id == 0 || typeof this.sablon.id === 'undefined'){
       this.text1 = "Şablon alanı boş geçilemez."
       this.snackbar = true
       return false;
   }



    this.loadingvmodel = true
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.progress = true

    this.prm.SirketKodu = credentials.SirketKodu

    var params = {
      prm: this.prm,
      objectName: 'Models.GenelAmacliRaporCariHesap',
      id: this.sablon.id,
    }

    this.load1 = false
    this.load = true

    tool.api_post_FileDownload(this, "RaporSablon/GetReportExcel", params).then(
      response => {
        this.loadingvmodel = false
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "GetReport.xlsx";
        link.click();
        this.progress = false
        this.load1 = true
        this.load = false
      },
      response => {
        this.progress = false
        this.load1 = true
        this.load = false
        this.loadingvmodel = false
      }
    );

  }
</script>

<style scoped>
  .button {
    margin-top: 35px;
  }

  .handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .close {
    float: right;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  input {
    display: inline-block;
    width: 50%;
  }

  .text {
    margin: 20px;
  }
</style>